import Badge from '$tablet-app/src/app/components/Badge';
import Markdown from '$tablet-app/src/app/components/Markdown';
import SVG from '$tablet-app/src/app/components/SVG';
import { getPrepNoteIcon } from '$tablet-app/src/app/recipes/prepNoteIcons';
import { PrepNoteIcon } from '$tablet-app/src/app/recipes/types';
import { PrepNote } from '@akin-home/recipes';
import { Text } from '@akin-home/text/native';
import React, { FC } from 'react';
import { View, ViewProps } from 'react-native';
import styled from 'styled-components/native';

interface Props extends ViewProps {
  step: PrepNote;
  number: number;
}

const PreparationStepGridItem: FC<Props> = ({ step, number, style }) => {
  return (
    <Container style={style}>
      <IconContainer>
        <StyledBadge text={number.toString()} />
        <SVG
          xml={getPrepNoteIcon[step.icon || PrepNoteIcon.bake]}
          height={120}
          width={205}
        />
      </IconContainer>

      {step.title ? <Text weight="bold">{step.title}</Text> : null}
      <Markdown>{step.description}</Markdown>
    </Container>
  );
};

const Container = styled(View)`
  gap: 10px;
  width: 100%;
`;

const IconContainer = styled.View`
  height: 190px;
  width: 100%;
  border-radius: 20px;
  background-color: rgba(5, 22, 51, 0.05);

  justify-content: center;
  align-items: center;
`;

const StyledBadge = styled(Badge)`
  position: absolute;
  top: 10px;
  left: 10px;
`;

export default PreparationStepGridItem;
